const shape = {
  borderRadius: 4
};
export default shape;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/createTheme/shape.js
// module id = 815
// module chunks = 25